import React from 'react';
import { css as reactCss } from '@emotion/react';

import { useCountryState } from '~src/main/context/country-state';
import { useGlobalState } from '~src/main/context/global-state';
import { useTranslate } from '~src/main/context/localization';

import { FullscreenMode } from '~src/main/fullscreen-internals/fullscreen-mode';
import { CountrySelectModalFullscreen } from './country-select-modal-fullscreen';

import { colors } from '~src/main/theme/colors';
import { Button } from '~src/main/ui/button';
import { Heading } from '~src/main/ui/heading';

export const CountrySelect: React.FC = () => {
  const tICU = useTranslate();
  const globalState = useGlobalState();
  const { updateCountry } = useCountryState();
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);

  if (!globalState.flags.enable_country_selector) {
    return null;
  }

  const renderModal = () => {
    if (!modalOpen) {
      return null;
    }
    return (
      <FullscreenMode>
        <CountrySelectModalFullscreen
          onClose={() => setModalOpen(false)}
          onSubmit={(newCountry: string) => {
            setModalOpen(false);
            updateCountry({
              country: newCountry,
              currency: undefined,
            });
          }}
        />
      </FullscreenMode>
    );
  };

  return (
    <>
      <Heading>{tICU('widget.country_select.HEADER')}</Heading>

      <Button css={[styles.button]} onClick={() => setModalOpen(true)}>
        {tICU(`country.${globalState.country}`)}
      </Button>

      {renderModal()}
    </>
  );
};

const styles = {
  button: reactCss({
    fontSize: '14px',
    lineHeight: '20px',
    padding: '16px',
    height: '60px',
    width: '100%',
    borderColor: colors.neutral85,
    borderStyle: 'solid',
    borderWidth: '1px',
    textAlign: 'left',
    marginBottom: '28px',
    ':hover': {
      borderColor: 'black',
    },
  }),
};
